export default __webpack_public_path__ + "static/media/pic7.c4f53c8d.jpg";